import PropTypes from 'prop-types';
import React from 'react';
import { Icon, Menu as BaseMenu, Typography } from 'antd';
import { subscribe } from 'alfa';
import { withTranslation } from 'react-i18next';

import Link from '../link';
import './header.scss';
import { AccountDetails } from './AccountDetails';

const { Title } = Typography;

const Header = ({ business, account, t }) => {
  if (!business) {
    return (<></>);
  }

  return (
    <div className="header-block">
      <div className="block-inner header-container">
        <div className="menu-container">
          <Title level={2}>{business.name}</Title>
          <BaseMenu
            mode="horizontal"
            theme="light"
            className="menu"
            selectable={false}
          >
            <BaseMenu.Item key="home">
              <Link to="/">
                <Icon type="home" />
                {t('home')}
              </Link>
            </BaseMenu.Item>

            <BaseMenu.Item key="accounts">
              <Link to="/accounts">
                <Icon type="wallet" />
                {t('accounts')}
              </Link>
            </BaseMenu.Item>
            <BaseMenu.Item key="managers">
              <Link to="/managers">
                <Icon type="idcard" />
                {t('managers')}
              </Link>
            </BaseMenu.Item>
            <BaseMenu.Item key="apikeys">
              <Link to="/api-keys">
                <Icon type="key" />
                {t('api_keys')}
              </Link>
            </BaseMenu.Item>
          </BaseMenu>
        </div>
        <AccountDetails account={account} />
      </div>
    </div>
  );
};

Header.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string,
    alias: PropTypes.string,
  }),
  business: PropTypes.shape({
    name: PropTypes.string,
  }),
  t: PropTypes.func,
};

export default subscribe(withTranslation()(Header), ['business', 'account']);
